import { useRef } from 'react';
import { Space } from 'antd';
import { useTranslation } from '../../../i18n';
import { Button } from '../../../button';
import { Box } from '../../../box';
import { service } from '../service';
import styles from '../style.module.less';
import { DragItem, Highlighter } from '../../component';
import { usePrimaryColor } from '../../hooks';
import { Signature, type SignatureRef } from './signature';
import type { ShotEyesSignatureProps } from './types';

export function ShotEyesSignatureDesignMode(props: ShotEyesSignatureProps): React.ReactElement {
  const signature = useRef<SignatureRef | null>(null);
  const [t] = useTranslation();
  const { rgbColor } = usePrimaryColor();

  if (props.name == null) {
    return (
      <DragItem title={t('ShotEyesSignature')} />
    );
  }
  function handleOk(): void {
    const value = signature.current?.getBase64();
    if (value == null) {
      return;
    }
    // 为了方面设计面板预览，直接保持 base64 字符串
    props.onPropsChange?.({ value });
  }

  function handleClear(): void {
    signature.current?.clear();
    props.onPropsChange?.({ value: undefined });
  }

  // 主题色
  const activeStyle = props.active === true ? {
    boxShadow: `${rgbColor} 0 0 3px`
  } : {};
  return (
    <Box
      className={styles.designBox}
      style={{ ...activeStyle, paddingLeft: service.getIndent(props.path) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
          require={props.validator === 'required'}
        />
      </Box>
      <Box className={styles.input}>
        <Box className={styles.canvasContainer}>
          <Signature {...props} ref={signature} height={200} />
          <Space className={styles.action}>
            <Button size='small' disabled label={t('清除')} onClick={handleClear} autoInsertSpace={false} />
            <Button size='small' disabled label={t('保存')} onClick={handleOk} autoInsertSpace={false} />
          </Space>
        </Box>
      </Box>
    </Box>
  );
}
